import React, { Component } from 'react';
import { defineMessages } from 'react-intl';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import requireAuth from '../../components/hoc/require-authentication';
import redirectAuthenticated from '../../components/hoc/redirect-authenticated';
import redirectPurchase from '../../components/hoc/redirect-purchase';
import redirectMobile from '../../components/hoc/redirect-mobile';
import loadPurchase from '../../components/hoc/load-purchase';
import verifyOrganizer from '../../components/hoc/verify-organizer';
import leaveIframe from '../../components/hoc/leave-iframe';
import LoadUser from '../../components/hoc/load-user';
import sessionHeartbeat from '../../components/hoc/session-heartbeat';

import Account from '../containers/account/index.container';
import Loading from '../../components/loading';
import SignIn from '../containers/signin.container';
import Logout from './logout';
import MakePurchase from '../containers/make-purchase/index.container';
import MyGroups from '../containers/my-groups/index.container';
import NotFoundError from './error-pages/not-found';
import OrganizerCommit from '../containers/organizer-commit/index.container';
import SinglePayerPayment from '../pages/single-payer-payment/single-payer-payment.container';
import SinglePayerPaymentConfirmation from '../pages/single-payer-payment/payment-successful';
import PasswordReset from './password-reset/index';
import PurchaseClaim from '../containers/purchase-claim/index.container';
import PurchaseDashboard from '../containers/purchase-dashboard/index.container';
import PurchaseLegalDocuments from '../containers/purchase-legal-documents/index.container';
import PurchaseConsumerFields from '../containers/purchase-consumer-fields/index.container';
import Signup from './signup';
import ServerError from './error-pages/server-error';
import SetNewPassword from '../containers/set-new-password/index.container';
import UnprocessableError from './error-pages/unprocessable';
import FacebookScript from '../../components/facebook-script';
import isMobile from '../../vendor/detect-mobile';
import Impersonate from '../containers/impersonate';

import '../css/desktop.css';

require('aemon/dist/desktop.css');

const inIframe = window !== window.top;

defineMessages({
  slot: {
    id: 'slot',
    defaultMessage: 'slot',
  },
  slots: {
    id: 'slots',
    defaultMessage: 'slots',
  },
  adult: {
    id: 'adult',
    defaultMessage: 'adult',
  },
  adults: {
    id: 'adults',
    defaultMessage: 'adults',
  },
  passenger: {
    id: 'passenger',
    defaultMessage: 'passenger',
  },
  passengers: {
    id: 'passengers',
    defaultMessage: 'passengers',
  },
  ticket: {
    id: 'ticket',
    defaultMessage: 'ticket',
  },
  tickets: {
    id: 'tickets',
    defaultMessage: 'tickets',
  },
  seat: {
    id: 'seat',
    defaultMessage: 'seat',
  },
  seats: {
    id: 'seats',
    defaultMessage: 'seats',
  },
  item: {
    id: 'item',
    defaultMessage: 'item',
  },
  items: {
    id: 'items',
    defaultMessage: 'items',
  },
  shirt: {
    id: 'shirt',
    defaultMessage: 'shirt',
  },
  shirts: {
    id: 'shirts',
    defaultMessage: 'shirts',
  },
  person: {
    id: 'person',
    defaultMessage: 'person',
  },
  people: {
    id: 'people',
    defaultMessage: 'people',
  },
  guest: {
    id: 'guest',
    defaultMessage: 'guest',
  },
  guests: {
    id: 'guests',
    defaultMessage: 'guests',
  },
  player: {
    id: 'player',
    defaultMessage: 'player',
  },
  players: {
    id: 'players',
    defaultMessage: 'players',
  },
  student: {
    id: 'student',
    defaultMessage: 'student',
  },
  students: {
    id: 'students',
    defaultMessage: 'students',
  },
  share: {
    id: 'share',
    defaultMessage: 'share',
  },
  shares: {
    id: 'shares',
    defaultMessage: 'shares',
  },
});

export default class App extends Component {
  componentWillMount() {
    this.cssClasses.forEach(klass => window.document.body.classList.add(klass));
  }

  get cssClasses() {
    const classes = [inIframe ? 'in-iframe' : 'no-iframe'];
    classes.push(isMobile ? 'mobile' : 'desktop');
    return classes;
  }

  render() {
    return (
      <Router>
        <div>
          {this.props.children}

          <FacebookScript />

          <Switch>
            <Route exact path="/" component={leaveIframe(requireAuth(redirectAuthenticated(Loading)))} />
            <Route path="/login" component={leaveIframe(redirectAuthenticated(SignIn))} />
            <Route path="/logout" component={leaveIframe(requireAuth(Logout))} />
            <Route path="/signup" component={leaveIframe(redirectAuthenticated(Signup))} />
            <Route path="/new-password" component={leaveIframe(SetNewPassword)} />
            <Route path="/account" component={leaveIframe(requireAuth(Account))} />
            <Route path="/my-groups" component={leaveIframe(requireAuth(MyGroups))} />
            <Route path="/password-reset" component={leaveIframe(redirectAuthenticated(PasswordReset))} />
            <Route path="/purchases/:id/claim" component={redirectMobile(loadPurchase(sessionHeartbeat(PurchaseClaim)))} />
            <Route
              path="/purchases/:id/purchase-fields"
              component={redirectMobile(loadPurchase(PurchaseConsumerFields))}
            />
            <Route
              path="/purchases/:id/organizer-commit"
              component={redirectMobile(LoadUser(loadPurchase(redirectPurchase(verifyOrganizer(OrganizerCommit)))))}
            />
            <Redirect from="/purchases/:id/single-payer-payment-submit" to="/purchases/:id/single-payer-payment" />
            <Route
              path="/purchases/:id/single-payer-payment"
              component={redirectMobile(LoadUser(loadPurchase(SinglePayerPayment)))}
            />
            <Route
              path="/purchases/:id/single-payer-payment-successful"
              component={redirectMobile(loadPurchase(SinglePayerPaymentConfirmation))}
            />
            <Route
              path="/purchases/:id/commit"
              component={redirectMobile(({ match: { params } }) => {
                return <Redirect to={`/purchases/${params.id}`} />;
              })}
            />
            <Route
              path="/purchases/:id/make-purchase"
              component={leaveIframe(redirectMobile(loadPurchase(redirectPurchase(verifyOrganizer(MakePurchase)))))}
            />
            <Route path="/purchases/:id/legal-documents" component={leaveIframe(PurchaseLegalDocuments)} />
            <Route
              path="/purchases/:id"
              component={leaveIframe(redirectMobile(loadPurchase(redirectPurchase(PurchaseDashboard))))}
            />
            <Route path="/impersonate" component={requireAuth(Impersonate)} />
            <Route path="/422" component={UnprocessableError} />
            <Route path="/500" component={ServerError} />
            <Route path="*" component={NotFoundError} />
          </Switch>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/desktop/components/app.js